import GradeFilterDto from "../dto/grade_filter";

export default class GradeFilter
{
	public grade!: string;
	public description!: string;
	public imageUrl!: string;
	public colour!: string;
	public inactive!: string;

	constructor(dto: GradeFilterDto)
	{
		Object.assign(this, dto);
	}
}